export default "__VITE_ASSET__BH5MRQ1E__"